import { __isEqual } from '.';

function isInArray(a, e) {
  for (var i = a.length; i--; ) if (__isEqual(a[i], e)) return true;
  return false;
}

export function isEqArrays(a1, a2) {
  if (a1.length !== a2.length) return false;
  for (var i = a1.length; i--; ) if (!isInArray(a2, a1[i])) return false;
  return true;
}

export { isEqArrays as areArraysWithExactContents };
